import DDKeyFigures from 'dd-keyfigures';
import de from "./locale/de.json";
import en from "./locale/en.json";
import I18N from "./i18n";
import globalOptions from "./global_options.ts";


const i18n = new I18N({ ...de, ...en });

console.log(globalOptions);

const settings = {
  mode: 'accordion',
  features: {
    printButton: {
      enabled: false
    }
  }

}

const chartData = {
  labels: [
    '2020',
    '2021',
    '2022',
  ],
  datasets: [
    {
      label: i18n.t("netsales.labels.sales"),
      unit: i18n.t("units.in_mio_euro"),
      table: i18n.t("units.mio_euro"),
      data: [19566, 20618, 24149],
      backgroundColor: '#0066CC',
    },
    {
      label: i18n.t("netsales.labels.humanpharma"),
      unit: i18n.t("units.in_mio_euro"),
      table: i18n.t("units.mio_euro"),
      data: [14415, 15294, 18461],
      backgroundColor: '#408C8C',
    },
    {
      label: i18n.t("netsales.labels.animalhealth"),
      unit: i18n.t("units.in_mio_euro"),
      table: i18n.t("units.mio_euro"),
      data: [4121, 4295, 4559],
      backgroundColor: '#006666',
    },
    {
      label: i18n.t("netsales.labels.biopharma"),
      unit: i18n.t("units.in_mio_euro"),
      table: i18n.t("units.mio_euro"),
      data: [837, 917, 1024],
      backgroundColor: '#999900',
    },
    {
      label: i18n.t("netsales.labels.other"),
      unit: i18n.t("units.in_mio_euro"),
      table: i18n.t("units.mio_euro"),
      data: [33, 112, 105],
      backgroundColor: '#CCCC00',
    }

  ]
};


const chartDataTwo = {
  labels: [
    '2020',
    '2021',
    '2022',
  ],
  datasets: [
    {
      label: i18n.t("operating.labels.operatingincome"),
      unit: i18n.t("units.in_mio_euro"),
      data: [4624, 4705, 4770],
      backgroundColor: '#0066CC',
    }
  ]
};


const chartDataThree = {
  labels: [
    '2020',
    '2021',
    '2022',
  ],
  datasets: [
    {
      label: i18n.t("investments.labels.investrd"),
      unit: i18n.t("units.in_mio_euro"),
      data: [3696, 4127, 5047],
      backgroundColor: '#990000',
    },
    {
      label: i18n.t("investments.labels.percent"),
      unit: i18n.t("units.in_percent"),
      data: [18.9, 20.0, 20.9],
      type: "line",
      backgroundColor: '#CC6633',
      yAxisID: "y2",
    }

  ]
};


const config = {
  'netsales': {
    type: 'bar',
    title: i18n.t("netsales.labels.sales"),
    data: chartData,
    options: globalOptions
  },

  'operatingincome': {
    type: 'bar',
    title: i18n.t("operating.labels.operatingincome"),
    data: chartDataTwo,
    options: globalOptions
  },

  'investments': {
    type: 'bar',
    title: i18n.t("investments.labels.investrd"),
    data: chartDataThree,
    options: globalOptions
  },

}

if (document.querySelector('#dd-keyfigures')) {
  const keyfigures = new DDKeyFigures(config, settings);
  keyfigures.init();
}
